import $ from "jquery";

const expertsAccordionToggler = () => {
  const init = () => {
    expertsAccordionToggle();
  };

  const expertsAccordionToggle = () => {
    const el = {
      accordionItem: ".expertsAccordion-item",
      accordionItemHeading: ".expertsAccordion-heading heading",
      accordionContent: ".expertsAccordion-content",
      accordionIcon: ".expertsAccordion-heading .icon",
    };

    $(el.accordionItem || el.accordionItemHeading).on("click", (e) => {
      const parent = $(e.target.closest(".expertsSection"));

      if (
        parent.find(`.${$(e.target).attr("data-target")}`).hasClass("closed")
      ) {
        parent.find($(el.accordionContent)).addClass("closed");
        parent.find($(el.accordionIcon)).addClass("closed");
        parent
          .find(`.${$(e.target).attr("data-target")}`)
          .removeClass("closed");
      } else {
        parent.find($(el.accordionContent)).addClass("closed");
        parent.find($(el.accordionIcon)).addClass("closed");
      }
    });
  };

  init();
};

try {
  expertsAccordionToggler();
} catch (error) {
  console.log(error);
}
